import type { BankIdMode } from "../services/types";

export const getBearerToken = () => sessionStorage.getItem("BearerToken") || "";

export const setBearerToken = (token: string) => {
	sessionStorage.setItem("BearerToken", token);
};

export const setRefreshToken = (token: string) => {
	sessionStorage.setItem("RefreshToken", token);
};

export const getRefreshToken = () => sessionStorage.getItem("RefreshToken") || "";

export const setRevision = (revision: string) => {
	sessionStorage.setItem("revision", revision);
};
export const getRevision = () => sessionStorage.getItem("revision") || "";

export const removeTokens = () => {
	sessionStorage.removeItem("revision");
	sessionStorage.removeItem("RefreshToken");
	sessionStorage.removeItem("BearerToken");
};

export const setBankIdMode = (mode: BankIdMode) => sessionStorage.setItem("bankIdMode", mode);
export const getBankIdMode = () => sessionStorage.getItem("bankIdMode");
